import {LedgerAccountInfo} from "./ledger-account-info";
import {SolutionManager} from "./solution-manager";

export class AccountSetting extends SolutionManager {
  transaction?: string;
  //Fixme: Use LookupType Enum, Keep the enum in sync with backend enum
  lookupType?: string;
  accountSettingsType?: string;
  ledgerAccountInfo?: LedgerAccountInfo;
  settingsCategoryType?: string;
  includeRootAccounts?: boolean;
  includeSubAccounts?: boolean;
  refId: number;
  ledgerAccountId: number;

  constructor (managingOrgId?: number) {
    super(managingOrgId);
  }
}


export class AccountSettingByCatgegory {

  settingsCategoryType: string;
  notMappedMarker?: boolean = false;
  accountSettings?: AccountSetting[];

}
